module.exports = __webpack_public_path__ + "img/px-fanbai.11e76812.png";